import { MultiStepSchema } from '../Types'
import { meta, PurposeAndGoalsSchema, TemplateSchema } from './Common'

export const FlowA2Schema = ({ generationType }: { generationType: string }) =>
  ({
    meta,
    steps: [PurposeAndGoalsSchema({ generationType }), TemplateSchema.meta({ forceFetchVideoTemplates: true })],
  } as MultiStepSchema)
